export default "__VITE_ASSET__B$JEBAvC__"